module.exports = __webpack_public_path__ + "static/img/3_1_1.53e26cd9.jpg";